export default [
  {
    name: 'BaseChangesCompaniesList',
    path: 'settings/companies/base-changes',
    component: () => import('pages/settings/base-changes/BaseChangesCompaniesList.vue')
  },
  {
    name: 'BaseChangesEdit',
    path: 'settings/companies/:id/base-changes/edit',
    component: () => import('pages/settings/base-changes/BaseChangesEdit.vue')
  },
  {
    name: 'BaseChangesList',
    path: 'base-changes',
    component: () => import('pages/base-changes/BaseChangesList.vue')
  }
]
